<template>
  <div>
    <a-card class="container">
      <a-row>
        <a-col :span="20">
          <a-form-model :colon="false" :model="form" layout="inline" @keyup.enter.native="query">
            <a-form-model-item label="申请人">
              <EmployeeSelector
                  style="width: 150px"
                  @change="onApplicantChange"
                  :value="form.applicantId ? [{ userId: form.applicantId, name: form.applicantName }] : []"
              >
                <a-input
                    style="width: 150px"
                    :value="form.applicantName"
                    placeholder="请选择申请人"
                    readOnly
                />
              </EmployeeSelector>
            </a-form-model-item>

<!--            <a-form-model-item label="入职日期">-->
<!--              <a-date-picker-->
<!--                  v-model="form.entryDate"-->
<!--                  placeholder="选择入职日期"-->
<!--                  style="width: 150px"-->
<!--              />-->
<!--            </a-form-model-item>-->

<!--            <a-form-model-item label="离职日期">-->
<!--              <a-date-picker-->
<!--                  v-model="form.leaveDate"-->
<!--                  placeholder="选择离职日期"-->
<!--                  style="width: 150px"-->
<!--              />-->
<!--            </a-form-model-item>-->

<!--            <a-form-model-item label="审批状态">-->
<!--              <a-select v-model="form.status" placeholder="审批状态" style="width: 150px" allowClear>-->
<!--                <a-select-option-->
<!--                    v-for="item in statusList"-->
<!--                    :key="item.value"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                  {{ item.name }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-model-item>-->

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
<!--        <a-col :span="4">-->
<!--          <div class="right" style="margin-top: 4px">-->
<!--            <a-space>-->
<!--              <a-button-->
<!--                  type="primary"-->
<!--                  v-if="$getPermission($route.path + '/add')"-->
<!--                  @click="$router.push($route.path + '/add')"-->
<!--              >新增-->
<!--              </a-button>-->
<!--            </a-space>-->
<!--          </div>-->
<!--        </a-col>-->
      </a-row>

      <Padding/>

      <a-table
          bordered
          :columns="columns"
          :data-source="list"
          :loading="loading"
          @change="onChange"
          :scroll="{ x: 1500 }"
          :pagination="{
            total,
            current,
            pageSize,
            showTotal: (total) => `共 ${total} 条记录`,
          }"
          rowKey="id"
      >
        <template slot="approveStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusName(text) }}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a
                href="#"
                v-if="$getPermission($route.path + '/detail')"
                @click.prevent="$router.push(`${$route.path}/detail?id=${record.id}`)"
            >
              详情
            </a>
            <a
                href="#"
                v-if="record.attachmentList && record.attachmentList.length > 0"
                @click.prevent="showAttachment(record.attachmentList)"
            >
              附件({{ record.attachmentList.length }})
            </a>
          </a-space>
        </template>
        <template slot="leaveReason" slot-scope="text">
          <span :title="text">{{ text }}</span>
        </template>
      </a-table>

      <AttachmentList
          :visible="attachmentVisible"
          :attachmentList="attachmentList"
          @close="attachmentVisible = false"
      />
    </a-card>
  </div>
</template>

<script>
import organization from "@/mixins/organization";
import EmployeeSelector from "@/components/employee-selector";
import AttachmentList from "./attachment-list.vue";
import {fetchList} from "@/api/human-resources/leave";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  mixins: [organization],
  components: {
    EmployeeSelector,
    AttachmentList
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("taskReviewStatus");
    },
    columns() {
      return [
        {
          title: '序号',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => (this.current - 1) * this.pageSize + index + 1
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'approveStatus'}
        },
        {title: '申请人', dataIndex: 'applicant', width: 100},
        {title: '申请部门', dataIndex: 'applyDept', width: 150},
        {title: '岗位或职务', dataIndex: 'position', width: 120},
        {
          title: '入职日期',
          dataIndex: 'entryDate',
          width: 120,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : ''
        },
        {
          title: '离职日期',
          dataIndex: 'leaveDate',
          width: 120,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : ''
        },
        {
          title: '参加工作时间',
          dataIndex: 'workStartDate',
          width: 120,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : ''
        },
        {
          title: '合同开始时间',
          dataIndex: 'contractStartDate',
          width: 120,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : ''
        },
        {
          title: '合同结束时间',
          dataIndex: 'contractEndDate',
          width: 120,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : ''
        },
        {
          title: '离职原因',
          dataIndex: 'leaveReason',
          width: 200,
          scopedSlots: {customRender: 'leaveReason'}
        },
        {
          title: '创建时间',
          dataIndex: 'createAt',
          width: 160,
          align: 'center',
          customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        {
          title: '操作',
          width: 140,
          align: 'center',
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ];
    }
  },
  data() {
    return {
      form: {
        applicantId: undefined,
        applicantName: undefined,
        entryDate: null,
        leaveDate: null,
        status: undefined
      },
      loading: false,
      list: [],
      total: 0,
      current: 1,
      pageSize: 10,
      attachmentVisible: false,
      attachmentList: []
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getStatusName(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return statusValue;
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.name : statusValue;
    },
    
    getStatusColor(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return statusValue;
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.icon : 'geekblue';
    },
    
    showAttachment(attachmentList) {
      this.attachmentList = attachmentList;
      this.attachmentVisible = true;
    },

    onApplicantChange(arr) {
      if (arr && arr.length > 0) {
        this.form.applicantId = arr[0].userId;
        this.form.applicantName = arr[0].name;
      } else {
        this.form.applicantId = undefined;
        this.form.applicantName = undefined;
      }
    },

    getList() {
      this.loading = true;
      const params = {
        pageNum: this.current,
        pageSize: this.pageSize
      };
      if (this.form.applicantId) {
        params.applicantId = this.form.applicantId;
      }
      if (this.form.entryDate) {
        params.entryDate = this.form.entryDate.format('YYYY-MM-DD');
      }
      if (this.form.leaveDate) {
        params.leaveDate = this.form.leaveDate.format('YYYY-MM-DD');
      }
      if (this.form.status !== undefined && this.form.status !== null && this.form.status !== '') {
        params.status = this.form.status;
      }
      fetchList(params)
          .then(res => {
            if (Array.isArray(res.list)) {
              this.list = res.list;
              this.total = res.totalSize || 0;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.current = 1;
      this.form = {
        applicantId: undefined,
        applicantName: undefined,
        entryDate: null,
        leaveDate: null,
        status: undefined
      };
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  /deep/ .ant-table {
    td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>